import { isAndroidChrome } from 'rev-shared/util/UserAgentUtil';

//Emoji popup and keyboard ui get into an unstable loop, shifting the ui forever.
const disableEmoji = isAndroidChrome();


export const SimpleToolbar: any[] = [
	'bold', 'italic', 'underline', 'removeFormat', '|',
	!disableEmoji && 'emoji'
].filter(Boolean);
